import React, { Component, Fragment } from 'react';
import {
    Container,
    Row, Col, Input, Label, Button, Form, FormGroup
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faTimes, faCircle, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import { faCircle as faCircleOutline } from '@fortawesome/free-regular-svg-icons'
import ConfirmButton from '../Modal/ConfirmButton';

class Departments extends Component {

    constructor(props) {
        super(props);

        this.blankDepartment = {
            departmentName: '',
            departmentOrder: 0,
            active: true
        }

        this.state = {
            newDepartment: { ...this.blankDepartment },
            editDepartment: { ...this.blankDepartment },
        };

    }

    onChange = (e, type) => {
        this.props.log('Departments.js/onChange (e,type)', e, type);
        e.persist();
        let thisDepartment = (type === 'edit') ? this.state.editDepartment : this.state.newDepartment;
        switch (e.target.name) {
            case "active":
                thisDepartment[e.target.name] = !thisDepartment[e.target.name];
                break;
            default:
                thisDepartment[e.target.name] = e.target.value;
        }
        this.setState(() => {
            return (type === 'edit') ? { editDepartment: thisDepartment } : { newDepartment: thisDepartment };
        });
    }

    onEdit = (id) => {
        this.props.log('Departments.js/onEdit (id)', id);
        const department = [...this.props.departments].filter(item => item.id === id)[0];
        this.setState(() => {
            return {
                editDepartment: {
                    'id': id,
                    'departmentName': department.departmentName,
                    'active': department.active,
                }
            }
        })
    }

    onDelete = (id) => {
        this.props.log('Departments.js/onDelete (id)', id);
        fetch('/api/departments/' + id, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.props.addToast('Department deleted successfully.', 5, 'success')
                    let departments = [...this.props.departments];
                    departments.splice(departments.findIndex(item => item.id === id), 1);
                    this.setState({
                        departments: departments,
                        editDepartment: { ...this.blankDepartment },
                    }, () => this.props.getDepartments());
                } else {
                    this.props.addToast('Unable to delete department.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    handleCancel = () => {
        this.props.log('Departments.js/handleCancel');
        this.setState({
            editDepartment: { ...this.blankDepartment },
        })
    }

    handleEdit = () => {
        this.props.log('Departments.js/handleEdit');
        fetch('/api/departments/' + this.state.editDepartment.id, {
            method: 'PUT',
            body: JSON.stringify({
                departmentName: this.state.editDepartment.departmentName,
                active: this.state.editDepartment.active,
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        editDepartment: { ...this.blankDepartment }
                    }, () => this.props.getDepartments());
                    this.props.addToast('Department updated successfully.', 5, 'success')
                } else {
                    this.props.addToast('Unable to update department.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    handleAdd = (e) => {
        this.props.log('Departments.js/handleAdd');
        fetch('/api/departments/', {
            method: 'POST',
            body: JSON.stringify({
                departmentName: this.state.newDepartment.departmentName,
                active: this.state.newDepartment.active,
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.props.addToast('Department added successfully.', 5, 'success')
                    this.setState({
                        newDepartment: { ...this.blankDepartment }
                    }, () => this.props.getDepartments());
                } else {
                    this.props.addToast('Unable to add department.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    standardRow = (department) => {
        this.props.info('Departments.js/standardRow (department)', department);
        return (
            <Row className="adminRow pointer" onClick={() => this.onEdit(department.id)}>
                <Col md={12} className="text-left">
                    <FontAwesomeIcon icon={(department['active']) ? faCircle : faCircleOutline} className={"mr-3 " + ((department['active']) ? 'iconActive' : 'iconInactive')} />
                    {department['departmentName']}
                </Col>
            </Row>
        )
    }

    editRow = (department) => {
        this.props.log('Departments.js/editRow (department)', department);
        return (
            <Row className="editRow adminRow activeTab">
                <Col md={8} className="text-left">
                    <Form inline>
                        <FormGroup className="pr-2">
                            <Input
                                placeholder="Department"
                                type="text"
                                id="departmentName-edit"
                                name="departmentName"
                                value={this.props.isFieldNull(this.state.editDepartment.departmentName)}
                                onChange={e => this.onChange(e, 'edit')} />
                        </FormGroup>
                        <FormGroup className="pr-2">
                            <Input
                                type="checkbox"
                                id={"edit-active" + department.id}
                                name="active"
                                checked={this.props.isFieldNull(this.state.editDepartment.active, true)}
                                onChange={e => this.onChange(e, 'edit')} />
                            <Label for={"edit-active" + department.id}>
                                Active
                            </Label>
                        </FormGroup>
                    </Form>
                </Col>
                <Col md={4} className="text-right">
                    <Button className="mx-1" color="success" onClick={this.handleEdit} title="Edit Department">
                        <FontAwesomeIcon icon={faCheck} />
                    </Button>
                    <ConfirmButton color="danger" className="mx-3"
                        onClick={() => this.onDelete(department.id)} title="Delete Department">
                        <FontAwesomeIcon icon={faTrashAlt} />
                    </ConfirmButton>
                    <Button className="mx-1" color="secondary" onClick={this.handleCancel} title="Cancel">
                        <FontAwesomeIcon icon={faTimes} />
                    </Button>
                </Col>
            </Row>
        )
    }

    addRow = () => {
        this.props.info('Departments.js/addRow');
        return (
            <Row className="py-4 text-left align-items-bottom ">
                <Col>
                    <Form inline>
                        <FormGroup className="px-2">
                            <Input
                                placeholder="New Department"
                                type="text"
                                id="departmentName-add"
                                name="departmentName"
                                value={this.props.isFieldNull(this.state.newDepartment.departmentName)}
                                onChange={e => this.onChange(e)} />
                        </FormGroup>
                        <FormGroup className="pr-2">
                            <Input
                                type="checkbox"
                                id={"departmentActive-add"}
                                name="active"
                                checked={this.props.isFieldNull(this.state.newDepartment.active, true)}
                                onChange={e => this.onChange(e)} />
                            <Label for={"departmentActive-add"}>
                                Active
                            </Label>
                        </FormGroup>
                    </Form>
                </Col>
                <Col md={3} className="text-right">
                    <Button
                        disabled={this.state.newDepartment.departmentName === ''}
                        color="primary"
                        onClick={this.handleAdd}
                    >Add Department</Button>
                </Col>
            </Row>
        )
    }

    render() {
        return (
            <Container className="adminContainer" fluid>
                {this.props.departments.map(department => (
                    <Fragment key={department.id}>{this.state.editDepartment.id === department.id ? this.editRow(department) : this.standardRow(department)}</Fragment>
                ))}
                {this.addRow()}
            </Container>
        );

    }
}

export default Departments;